export interface RoomDurationPrice {
  durationNights: number;
  price: number;
  nonAcPrice?: number;
}

function normalizeDurationPrices(input: unknown): RoomDurationPrice[] {
  if (!Array.isArray(input)) return [];
  const seen = new Map<number, RoomDurationPrice>();
  for (const item of input as Array<{
    durationNights?: unknown;
    price?: unknown;
    nonAcPrice?: unknown;
  }>) {
    const durationNights = Math.trunc(Number(item?.durationNights));
    const price = Number(item?.price);
    const nonAcPrice =
      item?.nonAcPrice !== undefined ? Number(item?.nonAcPrice) : undefined;
    if (!Number.isFinite(durationNights) || durationNights < 1) continue;
    if (!Number.isFinite(price) || price < 0) continue;
    seen.set(durationNights, {
      durationNights,
      price,
      nonAcPrice:
        nonAcPrice !== undefined &&
        Number.isFinite(nonAcPrice) &&
        nonAcPrice >= 0
          ? nonAcPrice
          : undefined,
    });
  }
  return [...seen.values()].sort((a, b) => a.durationNights - b.durationNights);
}

export function getRoomDurationPrices(room: {
  durationPrices?: unknown;
  price30Days?: unknown;
  price40Days?: unknown;
}): RoomDurationPrice[] {
  if (room.durationPrices != null)
    return normalizeDurationPrices(room.durationPrices);
  const legacy: RoomDurationPrice[] = [];
  if (room.price30Days != null)
    legacy.push({ durationNights: 30, price: Number(room.price30Days) });
  if (room.price40Days != null)
    legacy.push({ durationNights: 40, price: Number(room.price40Days) });
  return legacy;
}
